/**
 * SCSI MIDI Transport - MIDI communication via Pi SCSI bridge daemon
 *
 * This transport implements the MidiTransport interface by wrapping the
 * lower-level createScsiMidiTransport from midi-core. It enables
 * communication with SCSI-based samplers (e.g., Akai S3000XL) connected
 * via a Raspberry Pi running scsi2pi.
 */
import { createScsiMidiTransport as createScsiMidiCoreTransport, } from '@audiocontrol/midi-core';
function deviceToPortInfo(device) {
    return {
        id: `scsi-${device.id}`,
        name: `${device.vendor} ${device.product} (SCSI ${device.id})`,
        state: 'connected',
    };
}
export function createScsiMidiTransport(config) {
    const scsi = createScsiMidiCoreTransport({ bridgeUrl: config.bridgeUrl });
    let cachedDevices = [];
    const browserInfo = {
        supported: true,
        browser: 'SCSI MIDI',
        notes: 'MIDI via SCSI bridge on Raspberry Pi.',
    };
    async function scanAndMapPorts() {
        cachedDevices = await scsi.scanDevices();
        const ports = cachedDevices.map(deviceToPortInfo);
        // SCSI is bidirectional — inputs and outputs are the same
        return {
            inputs: ports,
            outputs: ports,
            sysExEnabled: true,
        };
    }
    return {
        kind: 'scsi-midi',
        isSupported: () => true,
        getBrowserInfo: () => browserInfo,
        initialize: async () => {
            await scsi.connect();
            return scanAndMapPorts();
        },
        refresh: async () => {
            return scanAndMapPorts();
        },
        // SCSI devices don't hot-plug — no state change events
        onStateChange: () => { },
        connect: async (inputId, _outputId) => {
            const device = cachedDevices.find((d) => `scsi-${d.id}` === inputId);
            if (!device) {
                throw new Error(`SCSI device not found for port: ${inputId}`);
            }
            const portInfo = deviceToPortInfo(device);
            return {
                adapter: scsi.adapter,
                sdsChannel: scsi.sdsChannel,
                inputInfo: portInfo,
                outputInfo: portInfo,
                disconnect: async () => {
                    scsi.disconnect();
                },
            };
        },
    };
}
//# sourceMappingURL=scsiMidiTransport.js.map